export class PageTitle {
	pageTitle: string;
	entityName?: string;
	route: string;
	entityId?: number | string;
	entityTypeId?: number;
	title?: string;
	filters?: any;
}
